__turbopack_context__.v({
  "action": "empty-state-module__SMuWUa__action",
  "description": "empty-state-module__SMuWUa__description",
  "emptyState": "empty-state-module__SMuWUa__emptyState",
  "pictogramWrapper": "empty-state-module__SMuWUa__pictogramWrapper",
  "title": "empty-state-module__SMuWUa__title",
});
